export default "__VITE_ASSET__BYIYYjLP__"